import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanApplicationChecklistResultsMap = createSelector(
  selectLoanApplication,
  ({ loanApplicationChecklistResults }) => loanApplicationChecklistResults,
);

export const selectLoanApplicationChecklistResultsList = createSelector(
  selectLoanApplicationChecklistResultsMap,
  loanApplicationChecklistResultsMap => Object.values(loanApplicationChecklistResultsMap),
);
